import { Model, NeoModel, Rules, Validation } from '@singularsystems/neo-core';

@NeoModel
export default class UnauthorisedCounterpartyCriteria extends Model.CriteriaBase {
    @Rules.Required()
    public counterpartyType: CounterpartyType | null = null;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<UnauthorisedCounterpartyCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Unauthorised Counterparty Criteria";
    }
}

export enum CounterpartyType {
    Investor = 1,
    Issuer = 2
}